export default "__VITE_ASSET__b53a0021__"